import React from "react";

import AuthContext, { IAuthContext } from "./AuthContext";

const useAuthContext = (): IAuthContext => {
    return React.useContext(AuthContext);
}

export default useAuthContext;
